import { GroundTypes } from "../consts/GroundTypes";
import { Tower } from "./Tower";

export class Field {
    public ground: GroundTypes = GroundTypes.GRAS;
    public tower: Tower | null = null;
    constructor(public position: [number, number]) {

    }
}